import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";


const Common = {
  gt_popup_open: false,
  init() {
    new LazyLoad();

    Common.events();
    Common.footer();
    Common.langSwitcher();
  },

  events() {
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitvids();

    // Video.
    $(".flex-video__overlay").on("click", function () {
      $(this).parent().addClass("playing").find("video")[0].play();
    });

    //Copy properties to clipboard
    $(".clipboard__icon").on("click", function () {
      // Get child text
      let output = null;
      let position = $(this).data("position");
      const name = $(this).data("name");
      const phone = $(this).data("phone");
      const email = $(this).data("email");

      const requsites = $(this).data("requisites");

      if (requsites != undefined) {
        output = requsites;
      } else {
        position = position.replace(/<br>/gi, "\n");
        output = `${position}\n${name}\n${phone}\n${email}`;
      }

      copyTextAsHtml(output);

      let allCopyButtons = $(".clipboard__icon");

      allCopyButtons.each(function () {
        if ($(this).data("requisites") != undefined) {
          $(this).parent().parent().find(".clipboard__tooltip-text").text(translations.copy_requisites);
        } else {
          $(this).parent().parent().find(".clipboard__tooltip-text").text(translations.copy_contact_card);
        }
      });

      let toolTip = $(this).parent().find(".clipboard__tooltip-text");
      toolTip.text(translations.copied);
    });

    /**
     * Copy text to clipboard as HTML to break lines
     */
    function copyTextAsHtml(text) {
      const input = document.createElement("textarea");
      input.innerHTML = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }

    // Update current language in the custom button
    // Create a MutationObserver to observe changes to the lang attribute of the html element
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "lang") {
          // Update the button text with the new language value
          let lang = $("html").attr("lang");
          if (lang === undefined || lang === "auto") {
            lang = "lv";
            $("button.lang-switch__toggle").text(lang.toUpperCase());
          } else {
            $("button.lang-switch__toggle").text(lang.toUpperCase());
          }
        }
      });
    });

    // Start observing the html element for attribute changes
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"]
    });
  },

  langSwitcher() {

    // Event listener for custom button
    $('.lang-switch__toggle').on('click', function () {
      if (Common.gt_popup_open) {
        Common.gt_hide_popup();
      } else {
        Common.gt_show_popup($('.gt_switcher-popup')[0]);
      }
    });

    // Listen for language change
    $(document).on('click', '.gt_white_content a', function () {
      var langName = $(this).find('span').text();
      $('.current-lang').text(langName);
    });

    // Close popup when clicking outside of it
    $(document).on("click", function (event) {
      if (
        Common.gt_popup_open &&
        !$(event.target).closest(".gt_white_content, .lang-switch__toggle").length
      ) {
        Common.gt_hide_popup();
      }
    });
  },


  gt_show_popup(el) {
    Common.gt_popup_open = true;
    $(el).parent().find('.gt_white_content a img:not([src])').each(function () {
      $(this).attr('src', $(this).data('gt-lazy-src'));
    });
    $(el).parent().find('.gt_white_content, .gt_black_overlay').show();
    $(".lang-switch__toggle").addClass("open"); // Add open class
  },
  gt_hide_popup() {
    Common.gt_popup_open = false;
    $('.gt_white_content, .gt_black_overlay').hide();
    $(".lang-switch__toggle").removeClass("open");
  },

  // Function to update the current language in the custom button
  updateCurrentLang() {
    var currentLangCode = $('html').attr('lang') || default_language;
    var currentLangName = lang_array[currentLangCode] || 'English';
    $('.current-lang').text(currentLangName);
  },


  footer() {
    const footerWrap = $(".footer");
    const footerEl = $(".footer-visual");
    if (!footerEl.length) {
      return;
    }
    if (window.innerWidth < 900) {
      return;
    }

    $(window).on("scroll", () => {
      let offset = 0;

      const windowScroll = $(window).scrollTop();

      const bottom = windowScroll + $(window).height();
      if (footerWrap.offset().top < bottom) {
        let elBottom = bottom - footerWrap.offset().top;
        let step = 0.5 * elBottom;
        offset = step - 220;
      }

      footerEl.css({
        transform: `translateX(-50%) translateY(${offset}px)`,
      });
    });
  },
};

export default Common;
